import axiosInstance from "./axios";

const getOrderData = async (businessId, orderUuid) => {
  try {
    return axiosInstance.get(`/orders/details/${businessId}/${orderUuid}`)
  }catch (e) {
    throw new Error(e.message)
  }
}

const order = {
  getOrderData,
}

export default order
